import { motion } from "motion/react";
import classNames from "classnames/bind";

import styles from "./Results.module.scss";
import { forwardRef } from "react";
const cx = classNames.bind(styles);

const SearchTrayNoResults = forwardRef<HTMLDivElement, { copy: string; }>(({ copy }, ref) => {
  return (
    <div className={cx("search-results")} ref={ref}>
      <p className="text-m">{copy}</p>
    </div>
  );
});

export default motion.create(SearchTrayNoResults);